/**
 * Search Enhancement Module
 * Enhances search functionality with better UX
 */

import { onDOMReady, devLog } from './utils.js';

class SearchEnhancement {
    constructor() {
        this.searchForms = document.querySelectorAll('.wp-block-search');
        this.init();
    }

    init() {
        if (this.searchForms.length === 0) return;
        
        this.searchForms.forEach(form => {
            this.enhanceSearchForm(form);
        });
    }

    enhanceSearchForm(form) {
        const input = form.querySelector('.wp-block-search__input');
        const wrapper = form.querySelector('.wp-block-search__inside-wrapper');
        
        if (!input || !wrapper) return;

        // Add focus/blur states
        input.addEventListener('focus', () => {
            wrapper.classList.add('search-focused');
        });

        input.addEventListener('blur', () => {
            wrapper.classList.remove('search-focused');
        });

        // Add value state
        input.addEventListener('input', () => {
            if (input.value.trim()) {
                wrapper.classList.add('search-has-value');
            } else {
                wrapper.classList.remove('search-has-value');
            }
        });

        // Handle form submission
        form.addEventListener('submit', (e) => {
            if (!input.value.trim()) {
                e.preventDefault();
                input.focus();
            }
        });

        // Add clear button if desired
        this.addClearButton(form, input, wrapper);
    }

    addClearButton(form, input, wrapper) {
        const clearButton = document.createElement('button');
        clearButton.type = 'button';
        clearButton.className = 'search-clear-button';
        clearButton.innerHTML = '×';
        clearButton.setAttribute('aria-label', 'Clear search');

        clearButton.addEventListener('click', () => {
            input.value = '';
            wrapper.classList.remove('search-has-value');
            input.focus();
            clearButton.style.display = 'none';
        });

        // Show/hide clear button based on input value
        input.addEventListener('input', () => {
            if (input.value.trim()) {
                clearButton.style.display = 'flex';
            } else {
                clearButton.style.display = 'none';
            }
        });

        wrapper.appendChild(clearButton);
    }
}

// Initialize when DOM is ready
onDOMReady(() => {
    new SearchEnhancement();
});

export default SearchEnhancement; 